<template>
<section class="flex md:flex-col">
    <div>
        <AdminDashboardNav/>
    </div>
    <section class="font-poppins w-screen pl-10 pr-10 md:p-2 ">
        <section class="mt-6">
            <div class=" flex justify-between md:flex-col-reverse ">
                <div class="md:mt-3">
                    <GetDate/>
                    <p class="text-blue-700 font-bold text-2xl md:text-lg">SETTINGS</p>
                </div>

                <div class=" mr-10">
                    <Notification/>
                </div>
            </div>


            <div>
                <div class="mt-14 font-bold">
                    <p>Profile Settings</p>
                </div>

                
                <div class="mt-10 flex md:flex-col ">
                    <div class="profile bg-gray-50 w-1/4 pl-4 pt-2 md:flex md:w-full md:justify-between md:h-16 md:text-xs border rounded-xl h-52">
                        <p @click="setSelectedTab('account-settings')" :class="{active: selectedTab === 'account-settings'}"  class=" cursor-pointer mt-6 border-b border-gray-200">Account</p>
                        <p @click="setSelectedTab('change-password')" :class="{active: selectedTab === 'change-password'}"  class="cursor-pointer mt-6 border-b border-gray-200">Change Password</p>
                        <p @click="setSelectedTab('delete-account')" :class="{active: selectedTab === 'delete-account'}"  class="cursor-pointer mt-6 border-b border-gray-200">Delete Account</p>
                       
                    </div>

                    <component class="md:mt-4" :is="selectedTab"></component>

                </div>    
            </div>
        </section>
    </section>
</section>    
</template>

<script>
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import AccountSettings from './AccountSettings.vue';
import ChangePassword from './ChangePassword.vue';
import DeleteAccount from './DeleteAccount.vue';
export default {
    components : {
        AdminDashboardNav,
        GetDate,
        Notification,
        AccountSettings,
        ChangePassword,
        DeleteAccount
    },

    data() {
        return {
            selectedTab: 'account-settings'
        };
    },

    mounted() {
        this.networkError()
    },

    methods: {
        setSelectedTab(tab) {
            this.selectedTab = tab
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

<style scoped>
.profile p:hover {
    color: blue;
}
</style>